import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onUpdateStatus, onReassignWorker, onGenerateDocuments, onExport, onClearSelection }) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-30">
      <div className="bg-primary text-primary-foreground rounded-lg shadow-lg px-6 py-4 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} />
          <span className="font-medium">{selectedCount} Klienten ausgewählt</span>
        </div>
        
        <div className="h-6 w-px bg-primary-foreground/20"></div>
        
        <div className="flex items-center gap-2">
          <Button variant="secondary" size="sm" iconName="RefreshCw" iconPosition="left" onClick={onUpdateStatus}>
            Status aktualisieren
          </Button>
          <Button variant="secondary" size="sm" iconName="UserCheck" iconPosition="left" onClick={onReassignWorker}>
            Sachbearbeiter zuweisen
          </Button>
          <Button variant="secondary" size="sm" iconName="FileText" iconPosition="left" onClick={onGenerateDocuments}>
            Dokumente erstellen
          </Button>
          <Button variant="secondary" size="sm" iconName="Download" iconPosition="left" onClick={onExport}>
            Exportieren
          </Button>
        </div>
        
        <div className="h-6 w-px bg-primary-foreground/20"></div>
        
        <button
          onClick={onClearSelection}
          className="p-1 hover:bg-primary-foreground/10 rounded transition-colors"
        >
          <Icon name="X" size={20} />
        </button>
      </div>
    </div>
  );
};

export default BulkActionsBar;